import * as i0 from '@angular/core';
import { Injectable, Component, Inject, EventEmitter, Optional, Input, ViewChild, Output, NgModule } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i4 from 'base-lca-soc-code-library';
import { BaseLcaSocCodeLibraryService } from 'base-lca-soc-code-library';
import { first } from 'rxjs/internal/operators/first';
import * as i1$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i7 from 'dirty-check-store';
import { MarkCleanFormAction } from 'dirty-check-store';
import * as i2 from '@ngrx/store';
import * as i2$1 from '@angular/router';
import * as i5 from 'ngx-toastr';
import * as i6 from 'step-status-update-payload-service';
import * as i8 from 'cache-country-list';
import * as i9 from 'reference-library';
import * as i10 from 'app-services-library';
import * as i12 from '@angular/common';
import * as i13 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i14 from 'primeng/inputtext';
import * as i15 from 'primeng/dropdown';
import * as i16 from 'primeng/api';
import * as i17 from 'primeng/radiobutton';
import * as i18 from '@angular/material/icon';
import * as i19 from 'primeng/button';
import * as i20 from 'primeng/divider';
import * as i21 from 'primeng/accordion';
import * as i22 from 'primeng/table';
import * as i23 from 'primeng/progressbar';
import * as i24 from 'primeng/panel';
import { PrimengLibraryModule } from 'primeng-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';

class LcaSocCodeLibraryService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    deleteOccupation(id) {
        return this.httpClient.delete(`/wizard/occupation/${id}/delete`).pipe(map((response) => {
            return response;
        }));
    }
}
LcaSocCodeLibraryService.ɵfac = function LcaSocCodeLibraryService_Factory(t) { return new (t || LcaSocCodeLibraryService)(i0.ɵɵinject(i1.HttpClient)); };
LcaSocCodeLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: LcaSocCodeLibraryService, factory: LcaSocCodeLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LcaSocCodeLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class ConfirmationModalComponent {
    constructor(dialogRef, dialogData, store) {
        this.dialogRef = dialogRef;
        this.dialogData = dialogData;
        this.store = store;
        this.buttons = [];
        this.dialogRef.disableClose = true;
    }
    ngOnInit() {
        this.title = this.dialogData.update.title;
        this.message = this.dialogData.update.message;
        this.buttons = (this.dialogData.buttons) ? this.dialogData.buttons : ['No', 'Yes'];
    }
    onConfirm() {
        // Close the dialog, return true
        this.dialogRef.close(true);
        this.store.dispatch(new MarkCleanFormAction({
            dirty: false
        }));
    }
    onDismiss() {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }
    handleNo() {
        this.dialogRef.close(false);
    }
}
ConfirmationModalComponent.ɵfac = function ConfirmationModalComponent_Factory(t) { return new (t || ConfirmationModalComponent)(i0.ɵɵdirectiveInject(i1$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i2.Store)); };
ConfirmationModalComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ConfirmationModalComponent, selectors: [["app-confirmation-modal"]], decls: 14, vars: 4, consts: [["mat-dialog-title", ""], [1, "col-md-12", "p-0", "row", "delete-header"], [1, "col-md-10", "p-0"], [1, "col-md-2", "p-0", "justify-content-end", "d-flex"], [1, "close-icon", "pi", "pi-times", 3, "click"], ["mat-dialog-content", "", 1, "message"], ["mat-dialog-actions", "", 1, "float-right"], ["mat-button", "", 1, "btn", "btn-secondary", 3, "click"], ["mat-raised-button", "", "color", "primary", 1, "btn", "btn-primary", 3, "click"]], template: function ConfirmationModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h5", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "i", 4);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_i_click_5_listener() { return ctx.handleNo(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "p");
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵelementStart(10, "button", 7);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_10_listener() { return ctx.onDismiss(); });
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 8);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_12_listener() { return ctx.onConfirm(); });
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.message);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.buttons[0]);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.buttons[1]);
    } }, directives: [i1$1.MatDialogTitle, i1$1.MatDialogContent, i1$1.MatDialogActions], styles: ["h5[_ngcontent-%COMP%]{color:#475f7b}input.update-dialog[_ngcontent-%COMP%]{border:.5px solid #d2d2d2;border-radius:.2em;height:34px}.message[_ngcontent-%COMP%]{border-top:2px dashed grey;padding-top:15px}button[_ngcontent-%COMP%]:last-child{margin-left:5px}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:10px;border-radius:20px;cursor:pointer;font-size:14px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmationModalComponent, [{
        type: Component,
        args: [{
                selector: 'app-confirmation-modal',
                templateUrl: './confirmation-modal.component.html',
                styleUrls: ['./confirmation-modal.component.scss']
            }]
    }], function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i2.Store }]; }, null); })();

const _c0 = ["lcaSocCodeForm"];
function LcaSocCodeLibraryComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "p", 26);
    i0.ɵɵelement(3, "i", 27);
    i0.ɵɵtext(4, "Selected LCA");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 28);
    i0.ɵɵelementStart(6, "div", 29);
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵelementStart(8, "mat-icon", 30);
    i0.ɵɵlistener("click", function LcaSocCodeLibraryComponent_div_0_Template_mat_icon_click_8_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.confirmDelete(); });
    i0.ɵɵtext(9, " delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 31);
    i0.ɵɵelementStart(11, "div", 32);
    i0.ɵɵelementStart(12, "div");
    i0.ɵɵelementStart(13, "label");
    i0.ɵɵtext(14, "Case No:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "span", 33);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 32);
    i0.ɵɵelementStart(18, "div");
    i0.ɵɵelementStart(19, "label");
    i0.ɵɵtext(20, "Status:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "span", 33);
    i0.ɵɵtext(22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 32);
    i0.ɵɵelementStart(24, "div");
    i0.ɵɵelementStart(25, "label");
    i0.ɵɵtext(26, "Period:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "span", 33);
    i0.ɵɵtext(28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 31);
    i0.ɵɵelementStart(30, "div", 34);
    i0.ɵɵelementStart(31, "div");
    i0.ɵɵelementStart(32, "p", 35);
    i0.ɵɵtext(33, "Job Title");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "h6", 33);
    i0.ɵɵtext(35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "div", 34);
    i0.ɵɵelementStart(37, "div");
    i0.ɵɵelementStart(38, "p", 35);
    i0.ɵɵtext(39, "SOC Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "h6", 33);
    i0.ɵɵtext(41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "div", 34);
    i0.ɵɵelementStart(43, "div");
    i0.ɵɵelementStart(44, "p", 35);
    i0.ɵɵtext(45, "Soc Job Title");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(46, "h6", 33);
    i0.ɵɵtext(47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(48, "div", 34);
    i0.ɵɵelementStart(49, "div");
    i0.ɵɵelementStart(50, "p", 35);
    i0.ɵɵtext(51, "Location");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(52, "h6", 33);
    i0.ɵɵtext(53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(54, "div", 34);
    i0.ɵɵelementStart(55, "div");
    i0.ɵɵelementStart(56, "p", 35);
    i0.ɵɵtext(57, "Wage Level:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(58, "h6", 33);
    i0.ɵɵtext(59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(16);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.lca == null ? null : ctx_r0.lca.caseNumber, "");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.lca == null ? null : ctx_r0.lca.status, "");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.lca == null ? null : ctx_r0.lca.period, "");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r0.lca == null ? null : ctx_r0.lca.jobTitle);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.lca == null ? null : ctx_r0.lca.socCode);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.lca == null ? null : ctx_r0.lca.socTitle);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.lca == null ? null : ctx_r0.lca.location);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.lca == null ? null : ctx_r0.lca.wageLevel);
} }
function LcaSocCodeLibraryComponent_div_1_h6_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6");
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "Select LCA");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LcaSocCodeLibraryComponent_div_1_h6_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6");
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "Select LCA SOC Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LcaSocCodeLibraryComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelementStart(1, "div", 37);
    i0.ɵɵtemplate(2, LcaSocCodeLibraryComponent_div_1_h6_2_Template, 3, 0, "h6", 24);
    i0.ɵɵtemplate(3, LcaSocCodeLibraryComponent_div_1_h6_3_Template, 3, 0, "h6", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isWizard);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.isWizard);
} }
function LcaSocCodeLibraryComponent_div_5_div_13_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵelementStart(1, "button", 48);
    i0.ɵɵlistener("click", function LcaSocCodeLibraryComponent_div_5_div_13_div_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(3); return ctx_r21.postSelectedSOCCode(1, false); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    const _r2 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", _r2.invalid || ctx_r20.disabledControls ? "btn-success button-width-icon-left pl-4 pr-4 mr-3 btn-success_disabled btn-un" : "btn-success button-width-icon-left pl-4 pr-4 mr-3 btn-un")("disabled", _r2.invalid || ctx_r20.disabledControls);
} }
function LcaSocCodeLibraryComponent_div_5_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, LcaSocCodeLibraryComponent_div_5_div_13_div_1_Template, 2, 2, "div", 46);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.isSimplifyH1b ? false : true);
} }
function LcaSocCodeLibraryComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵelementStart(1, "div", 39);
    i0.ɵɵelementStart(2, "label", 40);
    i0.ɵɵtext(3, "Select LCA from list");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-dropdown", 41);
    i0.ɵɵlistener("onChange", function LcaSocCodeLibraryComponent_div_5_Template_p_dropdown_onChange_4_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.onChangeLca(); })("ngModelChange", function LcaSocCodeLibraryComponent_div_5_Template_p_dropdown_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.lcaCodeId = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 42);
    i0.ɵɵelementStart(6, "h6", 43);
    i0.ɵɵlistener("click", function LcaSocCodeLibraryComponent_div_5_Template_h6_click_6_listener() { i0.ɵɵrestoreView(_r24); const ctx_r26 = i0.ɵɵnextContext(); return ctx_r26.enterLca(); });
    i0.ɵɵelementStart(7, "span", 44);
    i0.ɵɵtext(8, "OR");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(9, " Enter Registered/Approved LCA Details ");
    i0.ɵɵelementStart(10, "span", 45);
    i0.ɵɵtext(11, "OR");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(12, " EFile LCA");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, LcaSocCodeLibraryComponent_div_5_div_13_Template, 2, 1, "div", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r3.lcaList)("ngModel", ctx_r3.lcaCodeId);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngIf", ctx_r3.isWizardFlag);
} }
function LcaSocCodeLibraryComponent_p_divider_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider", 49);
} }
function LcaSocCodeLibraryComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵelementStart(1, "div", 50);
    i0.ɵɵelementStart(2, "h6");
    i0.ɵɵelementStart(3, "b");
    i0.ɵɵtext(4, "View SOC Code and Wage Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LcaSocCodeLibraryComponent_ng_template_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r27 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", item_r27.majorGroup, "-", item_r27.majorGroupName, " ");
} }
function LcaSocCodeLibraryComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "label", 12);
    i0.ɵɵtext(2, "State/District/Territory");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 52, 53);
    i0.ɵɵlistener("ngModelChange", function LcaSocCodeLibraryComponent_div_20_Template_p_dropdown_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.stateProvinceCode = $event; })("onChange", function LcaSocCodeLibraryComponent_div_20_Template_p_dropdown_onChange_3_listener() { i0.ɵɵrestoreView(_r30); const ctx_r31 = i0.ɵɵnextContext(); return ctx_r31.handleStateChange(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r9.listStates)("filter", false)("ngModel", ctx_r9.stateProvinceCode)("showClear", true)("disabled", ctx_r9.disabledControls);
} }
function LcaSocCodeLibraryComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "label", 12);
    i0.ɵɵtext(2, "County");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 54, 55);
    i0.ɵɵlistener("ngModelChange", function LcaSocCodeLibraryComponent_div_21_Template_p_dropdown_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(); return ctx_r33.county = $event; })("onChange", function LcaSocCodeLibraryComponent_div_21_Template_p_dropdown_onChange_3_listener() { i0.ɵɵrestoreView(_r34); const ctx_r35 = i0.ɵɵnextContext(); return ctx_r35.handleCountyChange(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r10.listCounty)("filter", false)("ngModel", ctx_r10.county)("showClear", true)("disabled", ctx_r10.disabledControls);
} }
function LcaSocCodeLibraryComponent_div_22_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵelementStart(1, "button", 66);
    i0.ɵɵlistener("click", function LcaSocCodeLibraryComponent_div_22_div_7_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r38); const ctx_r37 = i0.ɵɵnextContext(2); return ctx_r37.postSelectedSOCCode(2, ctx_r37.recommendedCode == null ? null : ctx_r37.recommendedCode.onetSocCode); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(2);
    const _r2 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", _r2.invalid || ctx_r36.disabledControls ? "btn-success button-width-icon-left pl-4 pr-4 mr-3 btn-success_disabled btn-un" : "btn-success button-width-icon-left pl-4 pr-4 mr-3 btn-un")("disabled", _r2.invalid || ctx_r36.disabledControls);
} }
function LcaSocCodeLibraryComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵelementStart(1, "div", 57);
    i0.ɵɵelementStart(2, "div", 58);
    i0.ɵɵelementStart(3, "span", 59);
    i0.ɵɵtext(4, "Recommended code to use");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 60);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, LcaSocCodeLibraryComponent_div_22_div_7_Template, 2, 2, "div", 61);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "p-divider", 49);
    i0.ɵɵelementStart(9, "div", 62);
    i0.ɵɵelementStart(10, "p-accordion");
    i0.ɵɵelementStart(11, "p-accordionTab", 63);
    i0.ɵɵelementStart(12, "span", 64);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.recommendedCode == null ? null : ctx_r11.recommendedCode.onetSocCode, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r11.isWizard);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r11.recommendedCode == null ? null : ctx_r11.recommendedCode.description);
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_2_th_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "th", 72);
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_2_th_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 74);
    i0.ɵɵtext(1, "Associate's");
    i0.ɵɵelementEnd();
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_2_th_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 74);
    i0.ɵɵtext(1, "Bachelor's");
    i0.ɵɵelementEnd();
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_2_th_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 74);
    i0.ɵɵtext(1, "Master's");
    i0.ɵɵelementEnd();
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_2_th_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 74);
    i0.ɵɵtext(1, "Education");
    i0.ɵɵelementEnd();
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_2_th_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 74);
    i0.ɵɵtext(1, "State");
    i0.ɵɵelementEnd();
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_2_th_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 74);
    i0.ɵɵtext(1, "County");
    i0.ɵɵelementEnd();
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_2_th_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 74);
    i0.ɵɵtext(1, "Wage Level");
    i0.ɵɵelementEnd();
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelement(1, "th", 72);
    i0.ɵɵtemplate(2, LcaSocCodeLibraryComponent_div_33_ng_template_2_th_2_Template, 1, 0, "th", 73);
    i0.ɵɵelementStart(3, "th", 74);
    i0.ɵɵtext(4, "SOC Code ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th", 75);
    i0.ɵɵtext(6, "Title");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th", 76);
    i0.ɵɵtext(8, "Alternate Title");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, LcaSocCodeLibraryComponent_div_33_ng_template_2_th_9_Template, 2, 0, "th", 77);
    i0.ɵɵtemplate(10, LcaSocCodeLibraryComponent_div_33_ng_template_2_th_10_Template, 2, 0, "th", 77);
    i0.ɵɵtemplate(11, LcaSocCodeLibraryComponent_div_33_ng_template_2_th_11_Template, 2, 0, "th", 77);
    i0.ɵɵtemplate(12, LcaSocCodeLibraryComponent_div_33_ng_template_2_th_12_Template, 2, 0, "th", 77);
    i0.ɵɵtemplate(13, LcaSocCodeLibraryComponent_div_33_ng_template_2_th_13_Template, 2, 0, "th", 77);
    i0.ɵɵtemplate(14, LcaSocCodeLibraryComponent_div_33_ng_template_2_th_14_Template, 2, 0, "th", 77);
    i0.ɵɵtemplate(15, LcaSocCodeLibraryComponent_div_33_ng_template_2_th_15_Template, 2, 0, "th", 77);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r39.isWizardFlag);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngIf", !ctx_r39.isWizardFlag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r39.isWizardFlag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r39.isWizardFlag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r39.isWizardFlag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r39.isWizardFlag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r39.isWizardFlag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r39.isWizardFlag);
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_3_tr_0_td_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 72);
    i0.ɵɵelement(1, "p-tableRadioButton", 81);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const code_r50 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", code_r50);
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_3_tr_0_td_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 74);
    i0.ɵɵelement(1, "p-progressBar", 82);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const code_r50 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", code_r50["5.0"]);
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_3_tr_0_td_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 74);
    i0.ɵɵelement(1, "p-progressBar", 82);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const code_r50 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", code_r50["6.0"]);
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_3_tr_0_td_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 74);
    i0.ɵɵelement(1, "p-progressBar", 82);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const code_r50 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", code_r50["8.0"]);
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_3_tr_0_td_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 74);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const code_r50 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Associate's - ", code_r50["5.0"], " %");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Bachelor's - ", code_r50["6.0"], " %");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Master's - ", code_r50["8.0"], " %");
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_3_tr_0_td_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 74);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const code_r50 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", code_r50 == null ? null : code_r50.stateProvinceName, " ");
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_3_tr_0_td_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 74);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const code_r50 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", code_r50 == null ? null : code_r50.county, " ");
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_3_tr_0_td_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 74);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const code_r50 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", code_r50 == null ? null : code_r50.wage, " ");
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_3_tr_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 78);
    i0.ɵɵelement(2, "button", 79);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, LcaSocCodeLibraryComponent_div_33_ng_template_3_tr_0_td_3_Template, 2, 1, "td", 73);
    i0.ɵɵelementStart(4, "td", 80);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td", 75);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td", 74);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, LcaSocCodeLibraryComponent_div_33_ng_template_3_tr_0_td_10_Template, 2, 1, "td", 77);
    i0.ɵɵtemplate(11, LcaSocCodeLibraryComponent_div_33_ng_template_3_tr_0_td_11_Template, 2, 1, "td", 77);
    i0.ɵɵtemplate(12, LcaSocCodeLibraryComponent_div_33_ng_template_3_tr_0_td_12_Template, 2, 1, "td", 77);
    i0.ɵɵtemplate(13, LcaSocCodeLibraryComponent_div_33_ng_template_3_tr_0_td_13_Template, 7, 3, "td", 77);
    i0.ɵɵtemplate(14, LcaSocCodeLibraryComponent_div_33_ng_template_3_tr_0_td_14_Template, 2, 1, "td", 77);
    i0.ɵɵtemplate(15, LcaSocCodeLibraryComponent_div_33_ng_template_3_tr_0_td_15_Template, 2, 1, "td", 77);
    i0.ɵɵtemplate(16, LcaSocCodeLibraryComponent_div_33_ng_template_3_tr_0_td_16_Template, 2, 1, "td", 77);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r69 = i0.ɵɵnextContext();
    const code_r50 = ctx_r69.$implicit;
    const expanded_r51 = ctx_r69.expanded;
    const ctx_r52 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pRowToggler", code_r50)("icon", expanded_r51 ? "pi pi-chevron-down" : "pi pi-chevron-right");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r52.isWizardFlag);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", code_r50.onetSocCode, " (", code_r50.onetSocVer, ")");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", code_r50.originalTitle ? code_r50.originalTitle : code_r50.title, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", !code_r50.originalTitle || code_r50.originalTitle == code_r50.title ? "--" : code_r50.title, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r52.isWizardFlag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r52.isWizardFlag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r52.isWizardFlag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r52.isWizardFlag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r52.isWizardFlag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r52.isWizardFlag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r52.isWizardFlag);
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, LcaSocCodeLibraryComponent_div_33_ng_template_3_tr_0_Template, 17, 14, "tr", 24);
} if (rf & 2) {
    const code_r50 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", code_r50);
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_4_li_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const task_r81 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", task_r81.task, " ");
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_4_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵtext(2, "Title");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r72 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r72.jobZone == null ? null : ctx_r72.jobZone.title);
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_4_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵtext(2, "Education");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r73 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r73.jobZone == null ? null : ctx_r73.jobZone.education);
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_4_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵtext(2, "Related Experience");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r74 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r74.jobZone == null ? null : ctx_r74.jobZone.experience);
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_4_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵtext(2, "Job Training");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r75 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r75.jobZone == null ? null : ctx_r75.jobZone.training);
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_4_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵtext(2, "Job Zone Examples");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r76 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r76.jobZone == null ? null : ctx_r76.jobZone.example);
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_4_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵtext(2, "SVP Range");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r77 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r77.jobZone == null ? null : ctx_r77.jobZone.svpRangae);
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_4_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, " No Data ");
    i0.ɵɵelementEnd();
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_4_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 93);
    i0.ɵɵelementStart(1, "div", 94);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵelementStart(3, "h6");
    i0.ɵɵtext(4, "Area");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵelementStart(8, "h6");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "p");
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div");
    i0.ɵɵelementStart(13, "h6");
    i0.ɵɵtext(14, "OES/SOC Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "p");
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 7);
    i0.ɵɵelementStart(18, "p");
    i0.ɵɵelementStart(19, "b");
    i0.ɵɵtext(20, "GeoLevel :");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "p");
    i0.ɵɵelementStart(23, "b");
    i0.ɵɵtext(24, "Level 1 Wage :");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "p");
    i0.ɵɵelementStart(27, "b");
    i0.ɵɵtext(28, "Level 2 Wage :");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "p");
    i0.ɵɵelementStart(31, "b");
    i0.ɵɵtext(32, "Level 3 Wage :");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "p");
    i0.ɵɵelementStart(35, "b");
    i0.ɵɵtext(36, "Level 4 Wage :");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "p");
    i0.ɵɵelementStart(39, "b");
    i0.ɵɵtext(40, "Mean Wage :");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const wage_r82 = ctx.$implicit;
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(wage_r82.area);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("Area Title : ", wage_r82.stateName, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(wage_r82.areaName);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(wage_r82.socCode);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", wage_r82.geoLvl, "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2(" ", wage_r82.level1Hourly, " /hour - ", wage_r82.level1Yearly, " /year");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2(" ", wage_r82.level2Hourly, " /hour - ", wage_r82.level2Yearly, " /year");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2(" ", wage_r82.level3Hourly, " /hour - ", wage_r82.level3Yearly, " /year");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2(" ", wage_r82.level4Hourly, " /hour - ", wage_r82.level4Yearly, " /year");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2(" ", wage_r82.averageHourly, " /hour - ", wage_r82.averageYearly, " /year");
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_4_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, " Work location information is not available. Hence wage level data could not be displayed. ");
    i0.ɵɵelementEnd();
} }
function LcaSocCodeLibraryComponent_div_33_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 83);
    i0.ɵɵelementStart(2, "div", 84);
    i0.ɵɵelementStart(3, "p-panel", 85);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 86);
    i0.ɵɵelementStart(6, "p-panel", 87);
    i0.ɵɵelementStart(7, "ul");
    i0.ɵɵtemplate(8, LcaSocCodeLibraryComponent_div_33_ng_template_4_li_8_Template, 2, 1, "li", 88);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 89);
    i0.ɵɵelementStart(10, "p-panel", 90);
    i0.ɵɵtemplate(11, LcaSocCodeLibraryComponent_div_33_ng_template_4_div_11_Template, 5, 1, "div", 24);
    i0.ɵɵtemplate(12, LcaSocCodeLibraryComponent_div_33_ng_template_4_div_12_Template, 5, 1, "div", 24);
    i0.ɵɵtemplate(13, LcaSocCodeLibraryComponent_div_33_ng_template_4_div_13_Template, 5, 1, "div", 24);
    i0.ɵɵtemplate(14, LcaSocCodeLibraryComponent_div_33_ng_template_4_div_14_Template, 5, 1, "div", 24);
    i0.ɵɵtemplate(15, LcaSocCodeLibraryComponent_div_33_ng_template_4_div_15_Template, 5, 1, "div", 24);
    i0.ɵɵtemplate(16, LcaSocCodeLibraryComponent_div_33_ng_template_4_div_16_Template, 5, 1, "div", 24);
    i0.ɵɵtemplate(17, LcaSocCodeLibraryComponent_div_33_ng_template_4_div_17_Template, 2, 0, "div", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 89);
    i0.ɵɵelementStart(19, "p-panel", 91);
    i0.ɵɵtemplate(20, LcaSocCodeLibraryComponent_div_33_ng_template_4_div_20_Template, 42, 15, "div", 92);
    i0.ɵɵtemplate(21, LcaSocCodeLibraryComponent_div_33_ng_template_4_div_21_Template, 2, 0, "div", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const code_r70 = ctx.$implicit;
    const ctx_r41 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", code_r70.description, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r41.listOfTasks);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r41.jobZone);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r41.jobZone);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r41.jobZone);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r41.jobZone);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r41.jobZone);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r41.jobZone);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r41.jobZone === null);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", code_r70 == null ? null : code_r70.wages);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r41.wageList == null ? null : ctx_r41.wageList.length) <= 0);
} }
function LcaSocCodeLibraryComponent_div_33_Template(rf, ctx) { if (rf & 1) {
    const _r85 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵelementStart(1, "p-table", 68);
    i0.ɵɵlistener("selectionChange", function LcaSocCodeLibraryComponent_div_33_Template_p_table_selectionChange_1_listener($event) { i0.ɵɵrestoreView(_r85); const ctx_r84 = i0.ɵɵnextContext(); return ctx_r84.selectedCode = $event; })("onRowExpand", function LcaSocCodeLibraryComponent_div_33_Template_p_table_onRowExpand_1_listener($event) { i0.ɵɵrestoreView(_r85); const ctx_r86 = i0.ɵɵnextContext(); return ctx_r86.onLCARowExpand($event); });
    i0.ɵɵtemplate(2, LcaSocCodeLibraryComponent_div_33_ng_template_2_Template, 16, 8, "ng-template", 69);
    i0.ɵɵtemplate(3, LcaSocCodeLibraryComponent_div_33_ng_template_3_Template, 1, 1, "ng-template", 70);
    i0.ɵɵtemplate(4, LcaSocCodeLibraryComponent_div_33_ng_template_4_Template, 22, 11, "ng-template", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("dataKey", ctx_r12.isWizard ? "codeStateCount" : "onetSocCode");
    i0.ɵɵproperty("value", ctx_r12.listOfSocCode)("selection", ctx_r12.selectedCode)("scrollable", true);
} }
function LcaSocCodeLibraryComponent_div_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "We do not have any recommendations of SOC codes for the selected job title ");
    i0.ɵɵelement(3, "br");
    i0.ɵɵtext(4, "Please click on the button Show All codes");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LcaSocCodeLibraryComponent_div_36_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r91 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 97);
    i0.ɵɵelementStart(1, "button", 48);
    i0.ɵɵlistener("click", function LcaSocCodeLibraryComponent_div_36_div_1_div_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r91); const ctx_r90 = i0.ɵɵnextContext(3); return ctx_r90.postSelectedSOCCode(1, false); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r88 = i0.ɵɵnextContext(3);
    const _r2 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", _r2.invalid || ctx_r88.disabledControls ? "btn-success button-width-icon-left pl-4 pr-4 mr-3 btn-success_disabled btn-un" : "btn-success button-width-icon-left pl-4 pr-4 mr-3 btn-un")("disabled", _r2.invalid || ctx_r88.disabledControls);
} }
function LcaSocCodeLibraryComponent_div_36_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r93 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 97);
    i0.ɵɵelementStart(1, "button", 98);
    i0.ɵɵlistener("click", function LcaSocCodeLibraryComponent_div_36_div_1_div_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r93); const ctx_r92 = i0.ɵɵnextContext(3); return ctx_r92.postSelectedSOCCode(1, false); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r89 = i0.ɵɵnextContext(3);
    const _r2 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", _r2.invalid || ctx_r89.disabledControls ? "btn-success button-width-icon-left pl-4 pr-4 mr-3 btn-success_disabled btn-un" : "btn-success button-width-icon-left pl-4 pr-4 mr-3 btn-un")("disabled", _r2.invalid || ctx_r89.disabledControls);
} }
function LcaSocCodeLibraryComponent_div_36_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 93);
    i0.ɵɵtemplate(1, LcaSocCodeLibraryComponent_div_36_div_1_div_1_Template, 2, 2, "div", 96);
    i0.ɵɵtemplate(2, LcaSocCodeLibraryComponent_div_36_div_1_div_2_Template, 2, 2, "div", 96);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r87 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r87.isSimplifyH1b ? false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r87.isSimplifyH1b ? true : false);
} }
function LcaSocCodeLibraryComponent_div_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, LcaSocCodeLibraryComponent_div_36_div_1_Template, 3, 2, "div", 95);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r14.show);
} }
var userRoleRouteMapping;
(function (userRoleRouteMapping) {
    userRoleRouteMapping["Petitioner"] = "petitioner-landing";
    userRoleRouteMapping["Attorney"] = "attorney-landing";
    userRoleRouteMapping["Beneficiary"] = "beneficiary-landing";
    userRoleRouteMapping["Platform"] = "platform-admin-landing";
})(userRoleRouteMapping || (userRoleRouteMapping = {}));
class LcaSocCodeLibraryComponent extends BaseLcaSocCodeLibraryService {
    constructor(dialog, router, store, apiService, toastr, stepStatusUpdatePayloadCostruction, guard, cacheCountyService, referenceLibraryService, appServicesLibraryService, lcaSocCodeLibraryService, primaryData) {
        super(store, apiService, toastr, stepStatusUpdatePayloadCostruction, guard, cacheCountyService, referenceLibraryService, appServicesLibraryService);
        this.dialog = dialog;
        this.router = router;
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.guard = guard;
        this.cacheCountyService = cacheCountyService;
        this.referenceLibraryService = referenceLibraryService;
        this.appServicesLibraryService = appServicesLibraryService;
        this.lcaSocCodeLibraryService = lcaSocCodeLibraryService;
        this.lcaList = [];
        this.isLcaSelected = false;
        this.onDialogClose = new EventEmitter();
        this.onDeleteLca = new EventEmitter();
        this.show = false;
        this.isSocDeleted = false;
        this.primaryData = primaryData !== undefined ? primaryData : false;
    }
    changeLca() {
        this.isLcaSelected = false;
    }
    ngOnInit() {
        this.isSimplifyH1b = this.simplifyH1b;
        this.inputData = this.primaryData;
        this.isWizard = this.isWizardFlag;
        //this.isLcaSelected = !!this.isWizardFlag;
        this.companyId = this.compId;
        this.lcaList = [];
        super.loadInit();
        // if (this.isWizard) {
        //   this.getLCAs();
        //   this.getSelectedSOCCode();
        // }
        if (this.isWizard) {
            this.getLCAs();
            this.lcaSocLoaded$.subscribe(loadingCompleted => {
                if (loadingCompleted) {
                    if (this.lcaCodeId) {
                        this.isSocDeleted = false;
                        this.isLcaSelected = true;
                    }
                    else {
                        this.isSocDeleted = true;
                        this.isLcaSelected = false;
                    }
                }
            });
        }
        this.showThisContent$.subscribe(val => {
            if (val == true) {
                this.show = true;
            }
            else {
                this.show = false;
            }
        });
    }
    enterLca() {
        this.onDeleteLca.emit(true);
        if (this.lca && this.lca.lcaCodeId) {
            sessionStorage.setItem('lcaId', this.lca.lcaCodeId);
        }
        sessionStorage.setItem('originPage', 'true');
        sessionStorage.setItem('originUrl', `${userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/immigration-wizard/upload/soc-code`);
        this.router.navigate([`${userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/immigration-wizard/upload/soc-code/lca/add-new`]);
    }
    dialogueInitializer(event, title, message, buttons) {
        const cordinates = event;
        const dialogRef = this.dialog.open(ConfirmationModalComponent, {
            width: '40%',
            data: {
                update: { title, message },
                buttons: buttons
            }
        });
        return dialogRef;
    }
    // confirmChange() {
    //   const title = 'Change LCA and SOC code';
    //   const message = 'Do you really want to the LCA and SOC code?';
    //   const buttons = ['No', 'Yes'];
    //   this.dialogueInitializer(event, title, message, buttons).afterClosed().subscribe(result => {
    //     if (result) {
    //       this.changeLca();
    //     }
    //   })
    // }
    confirmDelete() {
        const title = 'Change LCA and SOC code';
        const message = 'Are you sure you want to delete the selected LCA?';
        const buttons = ['I will go with the same', 'Delete'];
        this.dialogueInitializer(event, title, message, buttons).afterClosed().subscribe(result => {
            if (result) {
                this.changeLca();
                this.deleteLCA();
            }
        });
    }
    deleteLCA() {
        var _a;
        // code to add for delete lca
        let occupationId = (_a = this.occuapationDetails) === null || _a === void 0 ? void 0 : _a.id;
        this.lcaSocCodeLibraryService.deleteOccupation(occupationId).subscribe(res => {
            var _a, _b;
            this.toastr.success(res.message, "Success");
            this.isSocDeleted = true;
            this.listOfSocCode = [];
            this.recommendedCode = null;
            (_a = this.lcaSocCodeForm) === null || _a === void 0 ? void 0 : _a.reset();
            this.lcaCodeId = '';
            this.onChangeLca();
            sessionStorage.removeItem('savedLcaId');
            super.whenLcaChanged((_b = this.lcaList) === null || _b === void 0 ? void 0 : _b.find(val => val.id === this.lcaCodeId));
        });
    }
    onChangeLca() {
        var _a;
        //this.getSelectedSOCCode();
        let selLCA = (_a = this.lcaList) === null || _a === void 0 ? void 0 : _a.find(val => val.id == this.lcaCodeId);
        if (selLCA) {
            super.whenLcaChanged(selLCA);
        }
    }
    getLCAs() {
        this.apiService.getLcaCodesWizard(this.companyId).subscribe(data => {
            var _a;
            this.lcaList = data;
            if (this.lcaList.length) {
                //when lca is saved and came back on lca and soc page
                this.lcaList = data.map(x => {
                    return Object.assign(Object.assign({}, x), { displayName: x.comment ? `${x.caseNumber} - ${x.comment}` : `${x.caseNumber}` });
                });
                if (this.isWizard && sessionStorage.getItem('savedLcaId')) {
                    this.isSocDeleted = true;
                    this.isLcaSelected = false;
                    (_a = this.lcaSocCodeForm) === null || _a === void 0 ? void 0 : _a.reset();
                    this.lcaCodeId = parseInt(sessionStorage.getItem('savedLcaId'));
                    this.onChangeLca();
                }
                else {
                    //when come from task list. timer is set for the lcaCodeId
                    this.getSelectedSOCCode();
                    if (this.isWizard) {
                        setTimeout(() => {
                            if (this.lcaCodeId) {
                                this.isSocDeleted = false;
                                this.isLcaSelected = true;
                            }
                            else {
                                this.isSocDeleted = true;
                                this.isLcaSelected = false;
                            }
                        }, 3000);
                    }
                }
            }
            setTimeout(() => {
                var _a, _b;
                if (!((_a = this.lcaList) === null || _a === void 0 ? void 0 : _a.length) && this.lcaCodeId && this.lca) {
                    this.lcaList = [{ caseNumber: (_b = this.lca) === null || _b === void 0 ? void 0 : _b.caseNumber, id: this.lcaCodeId }];
                    if (this.isWizard && sessionStorage.getItem('savedLcaId')) {
                        this.isSocDeleted = true;
                        this.isLcaSelected = false;
                        this.lcaSocCodeForm.reset();
                        this.onChangeLca();
                    }
                    else {
                        this.getSelectedSOCCode();
                    }
                }
            }, 3000);
        });
    }
    ngAfterViewInit() {
        this.lcaSocCodeForm = this.lcaSocCodeForm;
        super.afterViewInit();
    }
    handleClose() {
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.onDialogClose.emit();
            }
            else {
                return false;
            }
        });
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
LcaSocCodeLibraryComponent.ɵfac = function LcaSocCodeLibraryComponent_Factory(t) { return new (t || LcaSocCodeLibraryComponent)(i0.ɵɵdirectiveInject(i1$1.MatDialog), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i4.APILCASOCCode), i0.ɵɵdirectiveInject(i5.ToastrService), i0.ɵɵdirectiveInject(i6.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i7.DirtyFormGuard), i0.ɵɵdirectiveInject(i8.CacheCountryListService), i0.ɵɵdirectiveInject(i9.ReferenceLibraryService), i0.ɵɵdirectiveInject(i10.AppServicesLibraryService), i0.ɵɵdirectiveInject(LcaSocCodeLibraryService), i0.ɵɵdirectiveInject('primaryData', 8)); };
LcaSocCodeLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LcaSocCodeLibraryComponent, selectors: [["lib-lca-soc-code-library"]], viewQuery: function LcaSocCodeLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.lcaSocCodeForm = _t.first);
    } }, inputs: { primaryData: "primaryData", compId: "compId", simplifyH1b: "simplifyH1b", isWizardFlag: "isWizardFlag" }, outputs: { onDialogClose: "onDialogClose", onDeleteLca: "onDeleteLca" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 37, vars: 20, consts: [["class", "px-3 mb-3", 4, "ngIf"], ["class", "row d-flex align-items-center", 4, "ngIf"], [3, "hidden"], ["lcaSocCodeForm", "ngForm"], ["class", "row pb-3", 4, "ngIf"], ["class", "row col-md-12 pl-0 pr-0", 4, "ngIf"], [1, "row", "mb-3"], [1, "col-md-6"], [1, "label-cls", "row", "required"], ["readonly", "true", "name", "positionTitle", "type", "text", "pInputText", "", 1, "im-input", "mw-100", 3, "ngModel", "ngModelChange"], ["positionTitleVar", "ngModel"], [1, "col-md-6", "pr-0", "form-group", "processing-dropdown"], [1, "label-cls", "required", "row"], ["appendTo", "body", "name", "selectedMajorGroupCode", "optionValue", "majorGroup", "optionLabel", "majorGroupName", "placeholder", "Select Group Code", "required", "", 3, "options", "filter", "ngModel", "showClear", "disabled", "ngModelChange", "onChange"], ["selectedMajorGroupCodeVar", "ngModel"], ["pTemplate", "item"], ["class", "col-md-6  pr-0 form-group processing-dropdown", 4, "ngIf"], ["class", "row m-3 recommendedCode", 4, "ngIf"], [1, "row", "mb-3", "pt-2", "socCodes"], ["label", "Recommended Codes", "name", "typeOfCode", "value", "0", 1, "letter-radio", 3, "ngModel", "onClick", "ngModelChange"], ["for", "recommended"], ["label", "Show All Codes", "name", "typeOfCode", "value", "1", 1, "letter-radio", 3, "ngModel", "onClick", "ngModelChange"], [1, "col-md-12", "mt-3", "mb-3", "codeDetail"], ["class", "col-md-12 pr-0", 4, "ngIf"], [4, "ngIf"], [1, "px-3", "mb-3"], [1, "text-success", "mb-2", "d-flex", "align-items-center"], [1, "fa", "fa-check-circle-o"], [1, "selected-lca-container", "py-3"], [1, "text-right"], ["matTooltip", "Delete", 1, "mr-1", "icn", 3, "click"], [1, "row", "border-bottom"], [1, "col-lg-4"], [1, "font-weight-bold"], [1, "col"], [1, "mb-0", "mt-2"], [1, "row", "d-flex", "align-items-center"], [1, "col-md-9", "step-title", "pb-3"], [1, "row", "pb-3"], [1, "col-6"], ["for", "lcaId", 1, "create-task-label"], ["inputId", "lcaId", "name", "lcaCodeId", "optionLabel", "displayName", "optionValue", "id", "placeholder", "Enter / Select", "appendTo", "body", 1, "w-100", 3, "options", "ngModel", "onChange", "ngModelChange"], [1, "col-6", "d-flex", "pl-0", "align-items-end"], [1, "text-primary", "font-weight-bold", "pt-4", 2, "cursor", "pointer", 3, "click"], [1, "text-dark", "mr-2"], [1, "text-dark", "mx-2"], ["class", "mr-3 d-flex justify-content-end mt-3 save-btn pb-2 textRight alignRight", 4, "ngIf"], [1, "mr-3", "d-flex", "justify-content-end", "mt-3", "save-btn", "pb-2", "textRight", "alignRight"], ["pButton", "", "type", "button", "label", "Save", 3, "ngClass", "disabled", "click"], [1, "row", "col-md-12", "pl-0", "pr-0"], [1, "col-12"], [1, "p-d-flex", "p-ai-center"], ["appendTo", "body", "name", "selectedState", "optionValue", "stateProvinceCode", "optionLabel", "stateProvinceName", "placeholder", "Select", "required", "", 3, "options", "filter", "ngModel", "showClear", "disabled", "ngModelChange", "onChange"], ["selectedState", "ngModel"], ["appendTo", "body", "name", "selectedCounty", "placeholder", "Select", "required", "", 3, "options", "filter", "ngModel", "showClear", "disabled", "ngModelChange", "onChange"], ["selectedCounty", "ngModel"], [1, "row", "m-3", "recommendedCode"], [1, "row", "col-md-12"], [1, "col-md-6", "p-0"], [1, "row", "label"], [1, "input"], ["class", "col-md-6 p-0 text-right pt-3 btn-un useNow", 4, "ngIf"], [1, "row", "col-md-12", "pl-0", "addList"], ["header", "Additional list of duties recommended"], [1, "addDesc"], [1, "col-md-6", "p-0", "text-right", "pt-3", "btn-un", "useNow"], ["pButton", "", "type", "button", "label", "Use Now!", 3, "ngClass", "disabled", "click"], [1, "col-md-12", "pr-0"], ["rowExpandMode", "single", "scrollHeight", "500px", 1, "pa-table", "im-card-no-border-table", "im-card-table-noborder-spacing", "table", 3, "value", "selection", "dataKey", "scrollable", "selectionChange", "onRowExpand"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "rowexpansion"], [2, "width", "2rem"], ["style", "width: 2rem", 4, "ngIf"], ["colspan", "1"], ["colspan", "2"], ["colspan", "1", 1, "alternate-column"], ["colspan", "1", 4, "ngIf"], [1, "imagilityFlagIcon", 2, "width", "2rem"], ["type", "button", "pButton", "", "pRipple", "", 1, "p-button-text", "p-button-rounded", "p-button-plain", 3, "pRowToggler", "icon"], ["colspan", "1", 1, "soc-code-value"], [1, "letter-radio", 3, "value"], [1, "lcaProgress", 3, "value"], ["colspan", "8"], [1, "pr-0", "pl-0", "row", "col-md-12", "lcaPanel"], ["header", "Summary"], [1, "pr-0", "pl-0", "row", "col-md-12", "pt-2", "lcaPanel"], ["header", "Tasks"], [4, "ngFor", "ngForOf"], [1, "row", "col-md-12", "pr-0", "pl-0", "pt-2", "lcaPanel"], ["header", "Job Zone"], ["header", "FCL Wage Level Results"], ["class", "row", 4, "ngFor", "ngForOf"], [1, "row"], [1, "body-socCode-para", "col-md-6"], ["class", " row", 4, "ngIf"], ["class", "col-md-12 save-btn pb-2 textRight alignRight", 4, "ngIf"], [1, "col-md-12", "save-btn", "pb-2", "textRight", "alignRight"], ["pButton", "", "type", "button", "label", "Save & Continue", 3, "ngClass", "disabled", "click"]], template: function LcaSocCodeLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LcaSocCodeLibraryComponent_div_0_Template, 60, 8, "div", 0);
        i0.ɵɵtemplate(1, LcaSocCodeLibraryComponent_div_1_Template, 4, 2, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "form", null, 3);
        i0.ɵɵtemplate(5, LcaSocCodeLibraryComponent_div_5_Template, 14, 3, "div", 4);
        i0.ɵɵtemplate(6, LcaSocCodeLibraryComponent_p_divider_6_Template, 1, 0, "p-divider", 5);
        i0.ɵɵtemplate(7, LcaSocCodeLibraryComponent_div_7_Template, 5, 0, "div", 4);
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵelementStart(9, "div", 7);
        i0.ɵɵelementStart(10, "label", 8);
        i0.ɵɵtext(11, " Position Title ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "input", 9, 10);
        i0.ɵɵlistener("ngModelChange", function LcaSocCodeLibraryComponent_Template_input_ngModelChange_12_listener($event) { return ctx.positionTitle = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 11);
        i0.ɵɵelementStart(15, "label", 12);
        i0.ɵɵtext(16, "Major Group Code");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "p-dropdown", 13, 14);
        i0.ɵɵlistener("ngModelChange", function LcaSocCodeLibraryComponent_Template_p_dropdown_ngModelChange_17_listener($event) { return ctx.selectedMajorGroupCode = $event; })("onChange", function LcaSocCodeLibraryComponent_Template_p_dropdown_onChange_17_listener() { return ctx.handleMajorGroupCodeChange(); });
        i0.ɵɵtemplate(19, LcaSocCodeLibraryComponent_ng_template_19_Template, 3, 2, "ng-template", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(20, LcaSocCodeLibraryComponent_div_20_Template, 5, 5, "div", 16);
        i0.ɵɵtemplate(21, LcaSocCodeLibraryComponent_div_21_Template, 5, 5, "div", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(22, LcaSocCodeLibraryComponent_div_22_Template, 14, 3, "div", 17);
        i0.ɵɵelementStart(23, "div", 18);
        i0.ɵɵelementStart(24, "div", 7);
        i0.ɵɵelementStart(25, "p-radioButton", 19);
        i0.ɵɵlistener("onClick", function LcaSocCodeLibraryComponent_Template_p_radioButton_onClick_25_listener() { return ctx.handleCodeTypeChange(); })("ngModelChange", function LcaSocCodeLibraryComponent_Template_p_radioButton_ngModelChange_25_listener($event) { return ctx.selectedCodeType = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(26, "label", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "div", 7);
        i0.ɵɵelementStart(28, "p-radioButton", 21);
        i0.ɵɵlistener("onClick", function LcaSocCodeLibraryComponent_Template_p_radioButton_onClick_28_listener() { return ctx.handleCodeTypeChange(); })("ngModelChange", function LcaSocCodeLibraryComponent_Template_p_radioButton_ngModelChange_28_listener($event) { return ctx.selectedCodeType = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "div", 22);
        i0.ɵɵelementStart(30, "span");
        i0.ɵɵelementStart(31, "b");
        i0.ɵɵtext(32, "LCA SOC Code Details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(33, LcaSocCodeLibraryComponent_div_33_Template, 5, 4, "div", 23);
        i0.ɵɵtemplate(34, LcaSocCodeLibraryComponent_div_34_Template, 5, 0, "div", 24);
        i0.ɵɵelement(35, "br");
        i0.ɵɵtemplate(36, LcaSocCodeLibraryComponent_div_36_Template, 2, 1, "div", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isLcaSelected === true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isLcaSelected === false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("hidden", ctx.isLcaSelected);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isWizard && ctx.isSocDeleted);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isWizard);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngModel", ctx.positionTitle);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("options", ctx.majourGroupCodeList)("filter", false)("ngModel", ctx.selectedMajorGroupCode)("showClear", true)("disabled", ctx.disabledControls);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isWizardFlag);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isWizardFlag);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.listOfSocCode && ctx.recommendedCode);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngModel", ctx.selectedCodeType);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngModel", ctx.selectedCodeType);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", !ctx.show);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.show);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isWizardFlag);
    } }, directives: [i12.NgIf, i13.ɵangular_packages_forms_forms_ba, i13.NgControlStatusGroup, i13.NgForm, i13.DefaultValueAccessor, i14.InputText, i13.NgControlStatus, i13.NgModel, i15.Dropdown, i13.RequiredValidator, i16.PrimeTemplate, i17.RadioButton, i18.MatIcon, i19.ButtonDirective, i12.NgClass, i20.Divider, i21.Accordion, i21.AccordionTab, i22.Table, i22.RowToggler, i22.TableRadioButton, i23.ProgressBar, i24.Panel, i12.NgForOf], styles: [".recommendedCode[_ngcontent-%COMP%], .selected-lca-container[_ngcontent-%COMP%]{background-color:#eff5fd}.recommendedCode[_ngcontent-%COMP%]{padding:20px 10px}.recommendedCode[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{font-size:24px;font-weight:500;color:#616161}.recommendedCode[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]{font-size:48px;font-weight:500;color:#616161}.recommendedCode[_ngcontent-%COMP%]   .btn-un[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:18px;text-align:center;padding:10px}.recommendedCode[_ngcontent-%COMP%]   .addList[_ngcontent-%COMP%]{font-size:24px;font-weight:500;color:#616161;font-family:Lato,sans-serif!important}.recommendedCode[_ngcontent-%COMP%]   .addDesc[_ngcontent-%COMP%]{font-size:14px;color:#616161;font-family:Lato,sans-serif!important}.codes[_ngcontent-%COMP%]   .recom-label[_ngcontent-%COMP%]   .label-radiobutton-label[_ngcontent-%COMP%]{font-weight:500;font-size:15px}.pa-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{vertical-align:bottom;border-bottom:2px solid #dee2e6;color:#4d4f5c;font-style:normal;font-variant:normal;font-weight:700;font-size:13px}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .pa-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{padding:15px 10px!important}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{color:#4d4848;border-top:none!important;font-size:12px!important}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:6px 8px!important;color:#75777a}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   .p-progressbar-label[_ngcontent-%COMP%]{font-size:12px!important}.pa-table[_ngcontent-%COMP%]   td.imagilityFlagIcon[_ngcontent-%COMP%]{padding:8px 0!important;border-right:none!important;text-align:center}.pa-table[_ngcontent-%COMP%]   td.imagilityFlagIcon[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:22px}.pa-table[_ngcontent-%COMP%]   td.imagilityFlagIcon[_ngcontent-%COMP%]   .flag-text[_ngcontent-%COMP%]{color:#2c2c2c;font-size:14px;padding:5px 10px}.main-body[_ngcontent-%COMP%]{height:calc(80vh - 216px);width:100%;overflow:auto;padding-right:10px;overflow-x:hidden}.useNow[_ngcontent-%COMP%]   .btn-success[_ngcontent-%COMP%]{background:#0091ff 0 0 no-repeat padding-box!important;border-radius:5px!important}.useNow[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#fff!important;font-family:Lato,sans-serif!important;font-size:24px!important}.letter-radio[_ngcontent-%COMP%]{font-size:16px!important;color:#333!important;font-family:Arial Rounded MT Bold!important}.codeDetail[_ngcontent-%COMP%]{font:normal normal 700 20px/28px Source Sans Pro!important;color:#616161!important}table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font:normal normal normal 16px/22px Source Sans Pro!important;color:#686868!important}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   b[_ngcontent-%COMP%]{color:#333!important;font:normal normal 700 16px/22px Source Sans Pro!important}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{color:#686868!important;font:normal normal normal 12px!important}.pa-table[_ngcontent-%COMP%]   td.soc-code-value[_ngcontent-%COMP%]{font-weight:700!important;font-size:12px!important}.lcaPanel[_ngcontent-%COMP%]   .p-panel[_ngcontent-%COMP%]   .p-panel-header[_ngcontent-%COMP%]   .p-panel-title[_ngcontent-%COMP%]{font:normal normal 700 16px/22px Source Sans Pro!important;color:#686868!important}.lcaPanel[_ngcontent-%COMP%]   .p-panel[_ngcontent-%COMP%]   .p-panel-content[_ngcontent-%COMP%]{font:normal normal normal 15px/21px Source Sans Pro!important;color:#686868!important}.alternate-column[_ngcontent-%COMP%]{width:115px}.textRight[_ngcontent-%COMP%]{text-align:right}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LcaSocCodeLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-lca-soc-code-library',
                templateUrl: 'lca-soc-code-library.component.html',
                styleUrls: ['lca-soc-code-library.component.scss'],
            }]
    }], function () { return [{ type: i1$1.MatDialog }, { type: i2$1.Router }, { type: i2.Store }, { type: i4.APILCASOCCode }, { type: i5.ToastrService }, { type: i6.StepStatusUpdatePayloadService }, { type: i7.DirtyFormGuard }, { type: i8.CacheCountryListService }, { type: i9.ReferenceLibraryService }, { type: i10.AppServicesLibraryService }, { type: LcaSocCodeLibraryService }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: ['primaryData']
            }] }]; }, { primaryData: [{
            type: Input
        }], compId: [{
            type: Input
        }], simplifyH1b: [{
            type: Input
        }], isWizardFlag: [{
            type: Input
        }], lcaSocCodeForm: [{
            type: ViewChild,
            args: ['lcaSocCodeForm', { static: true }]
        }], onDialogClose: [{
            type: Output
        }], onDeleteLca: [{
            type: Output
        }] }); })();

class LcaSocCodeLibraryModule {
}
LcaSocCodeLibraryModule.ɵfac = function LcaSocCodeLibraryModule_Factory(t) { return new (t || LcaSocCodeLibraryModule)(); };
LcaSocCodeLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: LcaSocCodeLibraryModule });
LcaSocCodeLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            FormsModule,
            ReactiveFormsModule,
            MatDialogModule,
            StepStatusUpdateComponentLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LcaSocCodeLibraryModule, { declarations: [LcaSocCodeLibraryComponent, ConfirmationModalComponent], imports: [PrimengLibraryModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        StepStatusUpdateComponentLibraryModule], exports: [LcaSocCodeLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LcaSocCodeLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [LcaSocCodeLibraryComponent, ConfirmationModalComponent],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MatDialogModule,
                    StepStatusUpdateComponentLibraryModule
                ],
                exports: [LcaSocCodeLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lca-soc-code-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LcaSocCodeLibraryComponent, LcaSocCodeLibraryModule, LcaSocCodeLibraryService, userRoleRouteMapping };
//# sourceMappingURL=lca-soc-code-library.js.map
